// extracted by mini-css-extract-plugin
export default {"container":"InfoContainer_container__rcFpD"};